<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editLark"
  >
    <Form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { editConfig } from '@/api/sys/robitConfig/dingding'
import Form from '@/components/sys/robitCofig/dingding/Form'

export default {
  name: 'editDingding',
  components:{
      Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '修改钉钉推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },
    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        let params = {
            id: formData.id,
            name: formData.robitName,
            desc: formData.desc,
            hookUrl: formData.hookUrl,
            secret: formData.secret,
            status: formData.status,
        }
        editConfig(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
